import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { JobAlertsComponent } from './job-alerts/job-alerts.component';
import { AddUpdateJobAlertComponent } from './add-update-job-alert/add-update-job-alert.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'list',
  },
  {
    path: '',
    component: JobAlertsComponent,
  },
  {
    path: 'add',
    component: AddUpdateJobAlertComponent,
  },
  {
    path: 'update/:id',
    component: AddUpdateJobAlertComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class JobAlertsRoutingModule {}
